import { render, staticRenderFns } from "./Quotas.vue?vue&type=template&id=b1b528e2&scoped=true&"
import script from "./Quotas.vue?vue&type=script&lang=js&"
export * from "./Quotas.vue?vue&type=script&lang=js&"
import style0 from "./Quotas.vue?vue&type=style&index=0&id=b1b528e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b528e2",
  null
  
)

export default component.exports